import type {
    ShippingPriceIndex,
    ShippingPriceIndexDetailVo,
    ShippingPriceIndexHotPagingParams,
    ShippingPriceIndexVo
} from "@zhihaoscm/entity";
import type { Page } from "../../../../common/types/base/BaseEntity";
import type { PriceIndexMonthStat } from "../../../../common/types/indexFreight";
import { MEMBER_PERMISSION } from "../../../../common/enum/member";
import { BaseService } from "./baseService";
import httpRequest from "./index";
import { decryptData, getPublicFileUrl, memberLimitDialog, validateMemberPermission } from "@/api/legacy";

export class IndexFreightService extends BaseService<any, any, any, any> {
    public async indexPage(params: any): Promise<Page<ShippingPriceIndexVo>> {
        let { data } = await this.service.get(`${this.path}/paging-v2`, { params });
        try {
            data = decryptData(data);
        } catch {
            // 兼容未加密的历史响应，解密失败时沿用接口原始数据。
        }
        return data;
    }

    /** 热门航线 */
    public async hotPaging(params: ShippingPriceIndexHotPagingParams): Promise<Page<ShippingPriceIndexVo>> {
        let { data } = await this.service.get(`${this.path}/hotPaging-v2`, { params });
        try {
            data = decryptData(data);
        } catch {
            // 兼容未加密的历史响应，解密失败时沿用接口原始数据。
        }
        return data;
    }

    // 获取运价指数折线图数据
    public async getShippingPriceIndexLine(params: any): Promise<PriceIndexMonthStat> {
        if (!validateMemberPermission(MEMBER_PERMISSION.shippingPriceIndexRead.code)) {
            return {};
        }
        let { data } = await this.service.get(`${this.path}/line`, { params });
        try {
            data = decryptData(data);
        } catch {
            // 兼容未加密的历史响应，解密失败时沿用接口原始数据。
        }
        return data;
    }

    public async findNewestDataByShipRouteId(shipRouteId: number): Promise<ShippingPriceIndex> {
        const { data } = await this.service.get(`${this.path}/newest/ship-route-id/${shipRouteId}`);
        return data;
    }

    // 获取最新的运价指数数据
    public async getLatestData(shipRouteId?: number): Promise<ShippingPriceIndex> {
        let url = `${this.path}/latest`;
        if (shipRouteId) url = url + `?shipRouteId=${shipRouteId}`;
        let { data } = await this.service.get(url);
        try {
            data = decryptData(data);
        } catch {
            // 兼容未加密的历史响应，解密失败时沿用接口原始数据。
        }
        return data;
    }

    // 置顶或者取消置顶指数
    public async setShippingPriceIndexTop(shipRouteId: number): Promise<any> {
        enum TopType {
            SHIPPING_PRICE_INDEX = 2
        }
        const { data } = await this.service.post(`/top/top`, {
            businessId: shipRouteId,
            type: TopType.SHIPPING_PRICE_INDEX
        });
        return data;
    }

    // 获取运价指数详情
    public async getShippingPriceIndexDetail(date: string, shipRouteId: number): Promise<ShippingPriceIndexDetailVo> {
        // 校验是否有会员权限
        if (!validateMemberPermission(MEMBER_PERMISSION.shippingPriceIndexRead.code)) {
            memberLimitDialog.open({
                blurImg: [getPublicFileUrl("index-detail-blur-1.png"), getPublicFileUrl("index-detail-blur-2.png")]
            });
        }
        let { data } = await this.service.get(`${this.path}/detail?date=${date}&shipRouteId=${shipRouteId}`);
        try {
            data = decryptData(data);
        } catch {
            // 兼容未加密的历史响应，解密失败时沿用接口原始数据。
        }
        return data;
    }
}
export const indexFreightService = new IndexFreightService("/shipping/price/index", httpRequest);
